<ng-template #dialogBody>
  <sco-tabs (changeEvent)="onTabChange($event.toString())">
    <sco-tab-item
      [id]="'changelog'"
      [title]="'NEWS' | translate"
      [badge]="changelogNewCount > 0 ? { state: 'success', value: changelogNewCount.toString() } : undefined">
    </sco-tab-item>
    <sco-tab-item
      [id]="'info'"
      [title]="'NEW_CONTENT' | translate"
      [badge]="contentNewCount > 0 ? { state: 'success', value: contentNewCount.toString() } : undefined">
    </sco-tab-item>
  </sco-tabs>

  <div class="tab-panel-content">
    @if (activeTabId === 'changelog') {
      @if (changelogEntries.length > 0) {
        <div>
          @for (entry of changelogEntries; track entry) {
            <div class="changelog-entry">
              <div class="changelog-content-header">
                <div>
                  <div class="entry-title">{{ entry.title }}</div>
                  <p class="changelog-date">{{ entry.published_date }}</p>
                </div>
                <div class="changelog-meta">
                  <sco-chips
                    [title]="'CHANGE_LOG.' + entry.content_type.toUpperCase() | translate"
                    variant="display"></sco-chips>
                </div>
              </div>
              @for (section of entry.contentSections; track section) {
                <div class="changelog-section" (click)="onContentClick($event)">
                  @if (section.title) {
                    <div class="section-title">{{ section.title }}</div>
                  }
                  <div [innerHTML]="section.content"></div>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        @if (data.url) {
          <iframe
            [src]="data.url"
            [width]="'100%'"
            [height]="'100%'"
            frameborder="0"
            allowfullscreen
            scrolling="auto"></iframe>
        }
      }
    } @else {
      <div class="news-category-list">
        @for (category of categories; track category.id) {
          <div class="news-category-item" (click)="onCategoryClick(category)">
            <div class="news-category-row">
              <img
                [src]="
                  category.cover_image
                    ? category.cover_image
                    : 'https://cdn.pixabay.com/photo/2017/11/10/04/47/image-2935360_1280.png'
                "
                alt=""
                class="news-category-thumbnail" />
              <div class="news-category-info">
                <span class="news-category-title">{{ category.title }}</span>
                @if (!isMobileView) {
                  <div class="news-category-breadcrumb">
                    @for (crumb of getCategoryBreadcrumb(category.id); track crumb; let last = $last) {
                      <span class="news-category-breadcrumb-item">{{ crumb }}</span>
                      @if (!last) {
                        <span class="news-category-breadcrumb-sep">&gt;</span>
                      }
                    }
                  </div>
                }
              </div>
              <div class="news-category-actions">
                <span class="news-category-dot">
                  @if (!category.seen) {
                    <sco-badge [size]="'small'" [state]="'success'"></sco-badge>
                  }
                </span>
                <span class="news-category-date">{{ formatCategoryDate(category.date) }}</span>
                <sco-display-chip
                  class="news-category-chip"
                  [label]="getCategoryChipLabelKey(category.type) | translate"
                  [signal]="false"></sco-display-chip>
                <i class="bi bi-box-arrow-up-right news-category-link-icon"></i>
              </div>
            </div>
            @if (isMobileView) {
              <div class="news-category-breadcrumb pt-2">
                @for (crumb of getCategoryBreadcrumb(category.id); track crumb; let last = $last) {
                  <span class="news-category-breadcrumb-item">{{ crumb }}</span>
                  @if (!last) {
                    <span class="news-category-breadcrumb-sep">&gt;</span>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Image Overlay -->
  @if (enlargedImageSrc) {
    <div class="image-overlay" (click)="closeEnlargedImage()">
      <div class="overlay-content">
        <img [src]="enlargedImageSrc" alt="Enlarged image" class="enlarged-image" />
      </div>
    </div>
  }
</ng-template>

@if (!isMobileView) {
  <sco-dialog
    [class]="'util-info-dialog'"
    (scoDialogCloseClicked)="closeDialogClicked()"
    [icon]="'bi bi-megaphone'"
    [title]="'NEWS' | translate">
    <div class="dialog-content">
      <ng-container *ngTemplateOutlet="dialogBody"></ng-container>
    </div>

    <!-- <ng-container footerLeft>
    <sco-checkbox
      [size]="'small'"
      [text]="'DIALOG_NOT_SHOW' | translate"
      [isChecked]="false"
      [disabled]="false"
      [isError]="false"
      (changeAction)="onCheckboxChange()"></sco-checkbox>
  </ng-container> -->

    <ng-container footerRight>
      <button scoButton variant="primary" (click)="close()">
        <i class="bi bi-x-lg"></i>
        {{ 'ERROR.CLOSE' | translate }}
      </button>
    </ng-container>
  </sco-dialog>
}

@if (isMobileView) {
  <div class="util-info-dialog-mobile-wrapper">
    <div class="mobile-header">
      <div class="mobile-header-title">
        <i class="bi bi-megaphone"></i>
        <span class="title">{{ 'NEWS' | translate }}</span>
      </div>
      <button scoButton variant="link" [onlyIcon]="true" (click)="closeDialogClicked()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="mobile-content">
      <ng-container *ngTemplateOutlet="dialogBody"></ng-container>
    </div>
    <div class="mobile-footer">
      <button scoButton variant="primary" (click)="close()">
        <i class="bi bi-x-lg"></i>
        {{ 'ERROR.CLOSE' | translate }}
      </button>
    </div>
  </div>
}
